import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'

import { Container } from './styles'

const FirstAccess = props => {
  document.title = 'Minha Veloe | Primeiro acesso'
  const vsgSdk = useVsgSdk()

  useEffect(() => {
    const firstAccessComponent = vsgSdk.renderizarPrimeiroAcesso({
      background: '/images/woman.png',
      showCnpj: false,
      loginType: 'cpf',
      title: 'Que legal ter você com a gente!',
      subtitle:
        'Estamos muito felizes com a sua chegada. Nós vamos te ajudar a ter mais tempo para o que você mais curte. Vamos começar, precisamos que você digite o CPF.',
      validationLinkMessage: 'Caso não tenha recebido, clique no botão “Reenviar e-mail”.'
    })

    firstAccessComponent.on('cancelar', () => {
      props.history.push('/conta/login')
    })
  }, [vsgSdk])

  return <Container id="vsg-primeiro-acesso" data-testid="vsg-primeiro-acesso" />
}

export default FirstAccess
